export default {"src":"/_next/static/media/stressMotivationMobile.02e8262c.svg","height":244,"width":272,"blurWidth":0,"blurHeight":0};